import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject, catchError, map, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class BordeoruService {
    private token!: string;
    private httpOptions: any;

    //   private borderouId = new Subject<{ borderouId: number }>();
    //   currentBorderouId$ = this.borderouId.asObservable();

    //   private borderouSlug = new Subject<{ borderouSlug: string }>();
    //   currentBorderouSlug$ = this.borderouSlug.asObservable();

    private basePath = environment.interop.basePath;

    private getBorderouDTURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou
            .borderouList;

    private getBorderouListURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou.list;

    private getBorderouListActiveURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderouDatatable.listActive

    private printBorderouURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou.print;

    private infoBorderouURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou.info;

    public downloadBorderouFileURL =
        this.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou.downloadBorderouFile;

    constructor(private http: HttpClient) { }

    //   changeRegistruId(borderou_id: { borderouId: number }) {
    //     this.borderouId.next(borderou_id);
    //   }

    //   changeBorderouSlug(borderou_slug: { borderouSlug: string }) {
    //     this.borderouSlug.next(borderou_slug);
    //   }

    print(data: any, type_slug: string) {
        return this.http.post(this.printBorderouURL + type_slug, data, {
            responseType: "blob",
        });
    }

    getBorderou() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getBorderouListURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get borderou types:", error);
                    return throwError(error);
                })
            );
    }

    getBorderouActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getBorderouListActiveURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                        slug: item.slug,
                    }))
                ),
                catchError((error) => {
                    console.error("Error in get borderou active types:", error);
                    return throwError(error);
                })
            );
    }

    infoBorderou(type_slug: string, date: string) {
        return this.http
            .get<{ errors: boolean; data: any; status_code: number }>(
                this.infoBorderouURL + type_slug + '/' + date
            )
            .pipe(
                map((response) => response.data
                ),
                catchError((error) => {
                    console.error("Error in get borderou info:", error);
                    return throwError(error);
                })
            );
    }

    getRegistreDT() {
        return this.http.get(this.getBorderouDTURL, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
